import type { ComputedRef, InjectionKey, Plugin } from 'vue';
import { createStorage } from 'unstorage';
import localStorageDriver from 'unstorage/drivers/localstorage';
import { computed, inject, ref } from 'vue';
import DebugDump from './DebugDump.vue';

interface DebugProvider {
  enable(): void;
  disable(): void;
  toggle(): void;
  enabled: ComputedRef<boolean>;
}

const debugToken: InjectionKey<DebugProvider> = Symbol.for('DebugProvider');

export const debugPlugin: Plugin = {
  install(app) {
    const storage = createStorage({ driver: localStorageDriver({ base: 'debug' }) });
    const debugEnabled = ref(false);

    storage.getItem('enabled').then(value => (debugEnabled.value = value as boolean));

    app.component('Dump', DebugDump);

    app.provide(debugToken, <DebugProvider>{
      enable() {
        debugEnabled.value = true;
      },
      disable() {
        debugEnabled.value = false;
      },
      toggle() {
        debugEnabled.value = !debugEnabled.value;
        storage.setItem('enabled', debugEnabled.value);
      },
      enabled: computed(() => debugEnabled.value),
    });
  },
};

export function useDebug(): DebugProvider {
  return inject(debugToken)!;
}
